import { OppButton } from '../ui/control';
import { TrendingUp } from 'lucide-react';

interface OppCourierUpgradeCardProps {
  visible: boolean;
  nextLevel: number;
  title: string;
  isPending: boolean;
  isSubmitted: boolean;
  submittedLabel: string;
  submittingLabel: string;
  buttonLabel: string;
  onSubmit: () => void;
}

export function OppCourierUpgradeCard({
  visible,
  nextLevel,
  title,
  isPending,
  isSubmitted,
  submittedLabel,
  submittingLabel,
  buttonLabel,
  onSubmit,
}: OppCourierUpgradeCardProps) {
  if (!visible) return null;

  return (
    <div className="rounded-xl border border-[hsl(var(--opp-border))] bg-[hsl(var(--opp-surface-raised))] p-4">
      <div className="mb-2 flex items-center gap-2">
        <TrendingUp className="h-4 w-4 text-[hsl(var(--opp-accent-strong))]" />
        <span className="text-sm font-semibold text-[hsl(var(--opp-ink))]">{title.replace('{level}', String(nextLevel))}</span>
      </div>
      {isSubmitted ? (
        <p className="rounded-lg bg-feedback-success/15 px-3 py-2 text-xs text-feedback-success">{submittedLabel}</p>
      ) : (
        <OppButton
          disabled={isPending}
          onClick={onSubmit}
          variant="primary"
          className="w-full rounded-full py-2 text-xs font-semibold disabled:opacity-40"
        >
          {isPending ? submittingLabel : buttonLabel}
        </OppButton>
      )}
    </div>
  );
}
